// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3Jfoj","title":"ClientInsurance_title__PhOig","itemText":"ClientInsurance_itemText__1AwlH"};